module.exports = __webpack_public_path__ + "media/entities/2206-b3913273.png";